import { render, staticRenderFns } from "./FolderTopMatter.vue?vue&type=template&id=5d2b19c8&scoped=true"
import script from "./FolderTopMatter.vue?vue&type=script&lang=ts"
export * from "./FolderTopMatter.vue?vue&type=script&lang=ts"
import style0 from "./FolderTopMatter.vue?vue&type=style&index=0&id=5d2b19c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b19c8",
  null
  
)

export default component.exports